// Spanish translation

const es = {
  "menu.staff_shift_schedule": "PROGRAMACION DE TURNOS",
  "staff.shift_scheduling": "Programación de Turnos",
  "staff.shift_scheduling.select_date": "Fecha",
  "staff.shift_scheduling.section": "Sección",
  "staff.shift_scheduling.days": "Dias",
  "staff.shift_scheduling.add_employees": "Agregar",
  "staff.shift_scheduling.start_date": "Fecha Inicial",
  "staff.shift_scheduling.end_date": "Fecha Final",
  "staff.shift_scheduling.add": "Agregar",
  "staff.shift_scheduling.update": "Actualizar",
  "staff.shift_scheduling.notes": "Notas",
  "staff.shift_scheduling.info": "Info. Turnos",
  "staff.shift.kinds": "Turnos",
  "staff.shift.shift_kind": "Turno",
  "staff.shift.shift_date": "Fecha",
  "staff.shift.cancel_shift": "Cancelar Turno",
  "staff.shift.form": "Turno Programado",
  "staff.shift.notes": "Notas",
  "staff.shift.employee": "Empleado",
  "staff.shift.total_time": "Tiempo Total",
  "staff.shift.state": "Estado",
  "staff.shift.section": "Sección",
  "staff.shift.event_category": "Novedad",
  "staff.shift.activity": "Actividad",
  "staff.shift.is_billable": "Es Facturable",
  "staff.shift.attendance": "Asistencia",
  "staff.shift.permits_checklist": "Novedades",
  "staff.shift.enter_permission": "Permiso de Entrada",
  "staff.shift.exit_permission": "Permiso de Salida",
  "staff.shift.enter_timestamp": "Hora Entrada",
  "staff.shift.exit_timestamp": "Hora Salida",
  "company.employee": "Empleados",
  "company.employee.position": "Cargo",
  "company.employee.party": "Empleado",
  "company.employee.code": "Cod",
  "staff.position": "Cargo",
  "staff.section": "Secciones",
  "staff.section.name": "Sección",
  "staff.shift.position": "Cargo",
  "staff.shift.day_to_compensate": "Dia a Compensar",
  "staff.shift.shift_amount": "Costo Turno",
  "staff.shift.schedule_het": "HET Programado",
  "staff.shift.het": "HET",
  "staff_access.shift_scheduling.report.start_date": "Fecha Inicial",
  "staff_access.shift_scheduling.report.end_date": "Fecha Final",
  "staff_access.shift_scheduling.report.section": "Sección",
  "staff_access.shift_scheduling.report": "Programación de Turnos",
  "staff_access.shift_scheduling_report.description":
    "Reporte detallado de Programación de Turnos por sección",
};

export default es;
